(function ($, Global) {
    function StaticPage() {
        // Déclaration class objet
    }

	StaticPage.prototype.initEvents = function () {
		this.publishers();
	}

	StaticPage.prototype.publishers = function () {
		navHorizontalPosition();

		$(window).on('resize scroll', function () {
			navHorizontalPosition();
		});
	}

	function navHorizontalPosition() {
		if ($(window).width() <= Global.viewports.sm) {
			if ($(window).scrollTop() > 30) {
				if ($('.nav-fixed .nav-horizontal').length == 0) $('.page .nav-horizontal').addClass('important').appendTo('.nav-fixed');
			} else {
				$('.nav-fixed .nav-horizontal').removeClass('important').prependTo($('.row > .content'));
			}
		}
	}

	Global.StaticPage = StaticPage;
}(jQuery, window));